import _slicedToArray from "/Users/stefan/coding/politik-jam/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { toggle } from "@nvon/baseline";
import { useCallback, useState } from "react";
/**
 * A wrapper for react's default useState, adding:
 *  - an additional toggle function
 *  - a () => set(true)
 *  - a () => set(false).
 *
 * Requires an initial state to be passed.
 */

export var useBooleanState = function useBooleanState(initialState) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      stateSetter = _useState2[1];

  var toggleFunction = useCallback(function () {
    return stateSetter(toggle);
  }, [stateSetter]);
  var enableFunction = useCallback(function () {
    return stateSetter(true);
  }, [stateSetter]);
  var disableFunction = useCallback(function () {
    return stateSetter(false);
  }, [stateSetter]);
  return {
    state: state,
    on: enableFunction,
    off: disableFunction,
    toggle: toggleFunction,
    set: stateSetter
  };
};